import { render, staticRenderFns } from "./TypePill.vue?vue&type=template&id=a81bb512"
import script from "./TypePill.vue?vue&type=script&lang=js"
export * from "./TypePill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports